export default __webpack_public_path__ + "static/Customer-Engagement-cf7375c50029ff9207f578defc6cfaa0.webp";